import { createFileRoute } from "@tanstack/react-router";
import {
  groupsListSearchSchema,
  type GroupsListSearch,
} from "@/features/groups/schemas";
import { fetchGroups } from "@/features/groups/queries";
import { queryKeys } from "@/lib/query-keys";
import { GroupsListPage } from "@/features/groups/pages/groups-list-page";

export const Route = createFileRoute("/_authed/tenants/$slug/groups/")({
  validateSearch: (raw: Record<string, unknown>): GroupsListSearch =>
    groupsListSearchSchema.parse(raw),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.groups.list(context.tenant.id, deps.search),
      queryFn: () => fetchGroups(context.tenant.id, deps.search),
    }),
  component: GroupsListPage,
});
